import { createStore }  from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
//import global reducer
import globalReducer from "./reducer/globalReducer";

// create defaultState

/*const defaultState = {
user,
header,
profile,

}
*/
const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, globalReducer)


  const store = createStore(persistedReducer);
  const persistor = persistStore(store)
  export { store, persistor }
